import { render, staticRenderFns } from "./Sample1229.vue?vue&type=template&id=7022c8d4&scoped=true&lang=pug&"
import script from "./Sample1229.vue?vue&type=script&lang=js&"
export * from "./Sample1229.vue?vue&type=script&lang=js&"
import style0 from "./Sample1229.vue?vue&type=style&index=0&id=7022c8d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7022c8d4",
  null
  
)

export default component.exports